export const FEATURE_FLAGS = {
  massMessaging: 'massMessaging',
} as const;

export type FeatureFlag = (typeof FEATURE_FLAGS)[keyof typeof FEATURE_FLAGS];
